
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/akqa/graph/[symbol]",
      function () {
        return require("private-next-pages/embed/akqa/graph/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/akqa/graph/[symbol]"])
      });
    }
  